// src/reducers/checkout/placeorderReducer.js
import {
    SUBSCRIBE_SUCCESS, SUBSCRIBE_FAILURE, CLEAR_SUBSCRIBE 
  } from "../../actions/types";
  
  const initialState = {
    placeorder: null,
    error: null,
  };
  
  export const subscribePlanReducer = (state = initialState, action) => {
    switch (action.type) {
      case SUBSCRIBE_SUCCESS:
        return {
          ...state,
          Plan: action.payload,
          error: null,
        };
      case SUBSCRIBE_FAILURE:
        return {
          ...state,
          Plan: null,
          error: action.payload,
        };
      case CLEAR_SUBSCRIBE:
        return {
          ...state,
          Plan: null,
          error: null,
        };
      default:
        return state;
    }
  };
  